import mutateCreateAsset from "./mutateCreateAsset"
import mutateCreateSlide from "./mutateCreateSlide"
import mutateUpdateSlide from "./mutateUpdateSlide"
import mutateDeleteSlide from "./mutateDeleteSlide"
import mutateReorderSlides from "./mutateReorderSlides"
import withSlideFormDetails from "./withSlideFormDetails"
import withSlides from "./withSlides"

const queries = {
  mutateCreateAsset,
  mutateCreateSlide,
  mutateUpdateSlide,
  mutateDeleteSlide,
  mutateReorderSlides,
  withSlideFormDetails,
  withSlides
}

export default queries



// WEBPACK FOOTER //
// ./src/Slides/queries/index.js